module.exports = __webpack_public_path__ + "img/product22p.2427085c.png";